import { AdminType, APIPost, APIUrl } from "api/protocols";

interface IPostTransaction {
  order_token: string;
  kind: string;
  amount: number;
  payment_option_id: number;
  gift_card_code?: string;
  gift_card_pin?: string;
  account_id?: number;
  credit_book_id?: number;
}

//New transaction endpoint. Supports card, gift card, credit book and house account payment options.
export async function PostTransactionNew(params: IPostTransaction, useGlobalLoader: boolean) {
  return await APIPost(APIUrl(AdminType.Customer, "/order/transaction/transaction-new"), params, useGlobalLoader);
}
